import {
  GET_REPORT_PENDING,
  GET_REPORT_SUCCESS,
  GET_REPORT_ERROR,
  TOGGLE_REPORT_MODAL,
  CANCEL_REPORT,
  GET_REPORT_FINISH,
  REPORT_IN_A_QUEUE,
  CLOSE_REPORT_MODAL,
  GET_HISTORY_REPORT_LIST,
  GET_HISTORY_REPORTS_LIST_SUCCESS,
} from '../constants/ActionTypes';

export const getHistoryReportList = () => ({
  type: GET_HISTORY_REPORT_LIST,
});

export const getHistoryReportsListSuccess = historyReportList => ({
  type: GET_HISTORY_REPORTS_LIST_SUCCESS,
  payload: historyReportList,
});

export const generateReport = (filters, reportName, reportType, source = 'routes') => ({
  type: GET_REPORT_PENDING,
  payload: { filters, fileName: reportName, reportType, source },
});

export const getReportError = error => ({
  type: GET_REPORT_ERROR,
  payload: error,
});

export const getReportSuccess = () => ({
  type: GET_REPORT_SUCCESS,
});

export const toggleReportModal = (selectedReport = null) => ({
  type: TOGGLE_REPORT_MODAL,
  payload: { selectedReport },
});

export const cancelReport = () => ({
  type: CANCEL_REPORT,
});

export const getReportFinish = () => ({
  type: GET_REPORT_FINISH,
});

export const showInQueueNotification = () => ({
  type: REPORT_IN_A_QUEUE,
});

export const closeReportModal = () => ({
  type: CLOSE_REPORT_MODAL,
});
